/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
import Button from '../../../../components/Button'
import { motion } from 'framer-motion'
import FileUploadInput from '../../../../components/FileUploadInput';
import { useDispatch, useSelector } from 'react-redux';
import { updateState, previewState, commitState, redo, undo, DEFAULT_CUSTOM_STORE_SETTINGS } from './CutomizationSlice';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Preview from './Preview';
import { ColorPicker } from 'antd';
import Confirmationpopup from '../../../manageAdminUser/components/Confirmationpopup';
import Modalcustom from '../../../../components/CustomModal';
import LogoUpload from '../../../../components/LogoUpload';
import GlobalContext from '../../../../components/Context/GlobalContext';
function StoreCustomize({ fonts, allowUpdate = false, setAllowUpdate = () => {}, state, setState, edit, handleSubmit, saveModal, setSaveModal, popUpHandler, saveLoading }) {

    //state used in this store customization componenet
    const [submitSelected, setSubmitSelected] = useState(false)
    const [imageLoading, setimageLoading] = useState(false);
    const [modal, setModal] = useState(false)
    const [hexColor, setHexColor] = useState('#000000');
    const custom_variable = useSelector(state => state.customization)
    const { setToastmessage, setToastErrorMessage, setToastError } = useContext(GlobalContext);
    
    const { custom, past, future, pendingPast } = custom_variable;
    // Undo/Redo are shown only when they would actually do something. An edit that is still in
    // progress (nothing committed yet) is undoable, so it counts towards canUndo.
    const canUndo = past?.length > 0 || pendingPast !== null;
    const canRedo = future?.length > 0;
    const [editing, setEditing] = useState(true)
    const dispatch = useDispatch();
    const divRefs = useRef([]);
    const fontRefs = useRef([]);
    const [localcustom, setCustom] = useState(custom)
    const [isFullImage, setIsFullImage] = useState(false)
    const [logoError, setLogoError] = useState('')

    const [dropdown, setDropdown] = useState({
        0: false,
        1: false,
        2: false,
        3: false,
    })

    const [fontDropdown, setFontDropdown] = useState({
        0: false,
        1: false,
    })

    const colorPickerArray = [
        {
            'title': 'Primary Color',
            'key': 'primary_color'

        },
        {
            'title': 'Title Text Color',
            'key': 'title_text_color',

        },
        {
            'title': 'Body Text Color',
            'key': 'body_text_color',
        },
        {
            'title': 'Background Color',
            'key': 'background_color',
        },
    ]

    const fontPickerArray = [
        {
            'title': 'Title font family',
            'key': 'title_font_family'

        },
        {
            'title': 'Body font family',
            'key': 'body_font_family'

        },
    ]

    const handleToggle = (i, key) => {
        setAllowUpdate(true)

        if (key) {
            setFontDropdown((prevState) => ({
                ...prevState,
                [i]: !prevState[i],
            }));
            return;
        }
        setDropdown((prevState) => ({
            ...prevState,
            [i]: !prevState[i],
        }));
    }

    const handleSubmitMain=(e)=>{
        setSubmitSelected(true)
        if(!edit && !state?.custom_store_settings?.store_logo){
            return
        }
        handleSubmit(e)
    }




    //function for taking the fonts

    const handlefontChange = (font, key) => {
        // setCustom((prevState) => ({
        //     ...custom,
        //     [key]: font,
        // }));
        dispatch(updateState({ [key]: font }))
    }
    const handleUndoRedo = (type) => {
        if (type === 'undo') {
            dispatch(undo());
        } else {
            dispatch(redo());
        }
    }

    const handleClose = () => {
        setModal(false)
    }

    // Store colours as plain 6-digit hex. An alpha channel was previously always appended
    // (`#9e2064ff`), which the customer app could not parse when tinting.
    function rgbToHex(r, g, b) {
        return "#" + componentToHex(Math.round(r)) + componentToHex(Math.round(g)) + componentToHex(Math.round(b));
    }

    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }

    // Applied on every change event so that dragging, the hue slider and the hex field all take
    // effect; the undo entry is recorded once the edit finishes (see handleColorEditEnd), because
    // dragging used to record one entry per mouse event and made a single Undo click imperceptible.
    const handleColorChange = (key, color) => {
        dispatch(previewState({ [key]: rgbToHex(color.metaColor.r, color.metaColor.g, color.metaColor.b) }))
    }

    // The picker's "complete" event covers dragging and the sliders but never fires for the hex
    // field, so the panel closing also ends the edit.
    const handleColorEditEnd = () => {
        dispatch(commitState())
    }
    // useEffect(() => {
    //     // debugger
    //     // if(edit && editing){
    //     //     debugger
    //     //     console.log(state?.custom_store_settings,'hello')
    //     //     let customObject = {...localcustom,...state?.custom_store_settings}
    //     //     console.log(customObject,'burrahhh');
    //     //     dispatch(updateState(customObject));
    //     //     setCustom(customObject);
    //     //     setEditing(false)
    //     //     return;
    //     // }
    //     // dispatch(updateState(localcustom));
    // }, [localcustom])
    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            'custom_store_settings': custom
        }));
    
    }, [custom]);
    useEffect(() => {
        if (divRefs.current.background_color) {
            let width = divRefs.current['primary_color'].offsetWidth;
            width = width - 24
            const elements = document.getElementsByClassName('ant-color-picker-inner-content');
            Array.from(elements).forEach((element) => {
                element.style.width = `${width}px`;
            });
        }

        const handleResize = () => {
            if (divRefs.current.background_color) {
                let width = divRefs.current.background_color.offsetWidth;
                width = width - 24
                const elements = document.getElementsByClassName('ant-color-picker-inner-content');
                Array.from(elements).forEach((element) => {
                    element.style.width = `${width}px`;
                });
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [dropdown]);
    // const hasClass = (key, className) => {
    //     debugger
    //     const div = divRefs.current[key];
    //     if (div) {
    //         return div.classList.contains(className);
    //     }
    //     return false;
    // };
    const [rotation, setRotation] = useState({});

    useEffect(() => {
        const interval = setInterval(() => {
            const newRotation = { ...rotation };
            colorPickerArray.forEach(item => {
                const hasClass = (key, className) => {
                    const div = divRefs.current[key];
                    if (div) {
                        return div.classList.contains(className);
                    }
                    return false;
                };

                newRotation[item.key] = hasClass(item.key, 'ant-popover-open') ? -180 : 0;
            });
            setRotation(newRotation);
        }, 150); // Check every 100ms

        return () => clearInterval(interval);
    }, [colorPickerArray, rotation]);

    const handleClickOutside = (event) => {
        const newFontDropdown = { ...fontDropdown };
        Object.keys(fontRefs.current).forEach((key, i) => {
            if (fontRefs.current[key] && !fontRefs.current[key].contains(event.target)) {
                newFontDropdown[i] = false;
            }
        });
        setFontDropdown(newFontDropdown);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [fontDropdown]);

    const handleCloseSave = () => {
        setSaveModal(false)
    }

    //toggle for full image view
    const handleFullToggle = () => {
        setAllowUpdate(true)
        setState(prevStore => ({
            ...prevStore,
            product_full_image_view: !prevStore.product_full_image_view
        }));
    }


    return (
        <div className='w-full border border-[#EB9DC7] px-4 pt-6'>
            {/* undo redo buttons starts here  */}
            {state?.custom_store_theme && (canUndo || canRedo) &&
                <div className='flex justify-end mb-6 space-x-6'>
                    {canUndo && <button
                        onClick={() => handleUndoRedo('undo')}
                        // loading={}
                        // disabled={loading}
                        data-testid={`undo-btn`}
                        text={"Undo"}
                        className={`px-9 py-2 bg-white rounded-[12px] border border-[#9E2064] text-[#9E2064] text-base font-normal`}
                        type="submit"
                        testId="undo-btn"
                    >Undo</button>}
                    {canRedo && <button
                        onClick={() => handleUndoRedo('redo')}
                        // loading={}
                        // disabled={loading}
                        data-testid={`redo-btn`}
                        text={"Redo"}
                        className={`px-9 py-2 bg-white rounded-[12px] border border-[#9E2064] text-[#9E2064] text-base font-normal`}
                        type="submit"
                        testId="redo-btn"
                    >Redo</button>}
                </div>}
            {/* undo redo buttons ends here  */}

            {/* color selection starts here   */}
            <h1 className='text-lg font-normal text-[#1f1f1f] mb-[22px]'>Color</h1>
            {state?.custom_store_theme ? (<div className='flex mb-8 -mx-3'>
                {colorPickerArray.map((item, i) => (

                    <div className='relative w-1/4 px-3' key={item?.title}>
                        <ColorPicker value={custom?.[item?.key]} onChange={(color) => handleColorChange(item?.key, color)} onChangeComplete={handleColorEditEnd} onOpenChange={(isOpen) => !isOpen && handleColorEditEnd()} disabledAlpha placement="bottom">
                            <div
                                className={`py-[14px] ${state?.custom_store_theme ? 'border border-[#DDDDDD]' : ''} px-4 flex justify-between cursor-pointer`}
                                onClick={() => state?.custom_store_theme && handleToggle(i)}
                                ref={(el) => (divRefs.current[item?.key] = el)}
                                data-testid={`${item.key}-btn`}
                            >
                                <div className='flex items-center space-x-3'>
                                    <div className={`w-7 h-7 rounded-full border border-[#E2E2E2]`} style={{ backgroundColor: custom?.[item?.key] || DEFAULT_CUSTOM_STORE_SETTINGS[item?.key], border: `1px solid #E2E2E2` }}></div>
                                    <p className='font-normal text-base text-[#1f1f1f]'>{item?.title}</p>
                                </div>
                                {state?.custom_store_theme &&
                                    (<div>
                                        <motion.img
                                            animate={{ rotate: rotation[item.key] || 0 }}
                                            src="/assets/images/chevron-down.svg"
                                            alt="" />
                                    </div>)}
                            </div>
                        </ColorPicker>
                    </div>

                ))}

            </div>) : (
                <div className='flex mb-8 -mx-3'>
                    <div className='relative w-1/4 px-3'>
                        <div className='flex items-center space-x-3'>
                            <div className={`w-7 h-7 bg-[#9E2064] rounded-full border border-[#E2E2E2]`} ></div>
                            <p className='font-normal text-base text-[#1f1f1f]'>Primary Color</p>
                        </div>
                    </div>
                    <div className='relative w-1/4 px-3'>
                        <div className='flex items-center space-x-3'>
                            <div className={`w-7 h-7 bg-[#1f1f1f] rounded-full border border-[#E2E2E2]`} ></div>
                            <p className='font-normal text-base text-[#1f1f1f]'>Title Text Color</p>
                        </div>
                    </div>
                    <div className='relative w-1/4 px-3'>
                        <div className='flex items-center space-x-3'>
                            <div className={`w-7 h-7 bg-[#666666] rounded-full border border-[#E2E2E2]`} ></div>
                            <p className='font-normal text-base text-[#1f1f1f]'>Body Text Color</p>
                        </div>
                    </div>
                    <div className='relative w-1/4 px-3'>
                        <div className='flex items-center space-x-3'>
                            <div className={`w-7 h-7 bg-[#f7f7f7] rounded-full border border-[#E2E2E2]`} ></div>
                            <p className='font-normal text-base text-[#1f1f1f]'>Background Color</p>
                        </div>
                    </div>
                </div>
            )}

            {/* color selection ends here   */}

            {/* font picker starts here  */}
            <h1 className='text-lg font-normal text-[#1f1f1f] mb-[22px]'>Typography</h1>
            {state?.custom_store_theme ? (<div className='flex mb-8 -mx-3'>
                {fontPickerArray.map((item, i) => (
                    <div className='relative w-1/4 px-3' key={item?.title}>

                        <div className='absolute w-full pr-5 bg-white'>
                            <div className="dropdown"
                                ref={(el) => (fontRefs.current[item?.key] = el)}
                            >
                                <div className={`w-full relative`}>
                                    <div className='relative w-full'>
                                        <input
                                            type="text"
                                            className={`${submitSelected && (custom[item?.key] === "" || !custom[item?.key]) ? "input-error" : "input-border"} peer m-0 block pt-4 h-[58px] w-full cursor-pointer rounded border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 text-base font-semibold leading-tight text-black transition duration-200 ease-linear placeholder:text-transparent  focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-black focus:outline-none peer-focus:text-black dark:border-neutral-600 dark:text-black  dark:focus:border-primary dark:peer-focus:text-primary`}
                                            id={`fonts-${i}`}
                                            data-testid={`${item?.key}`}
                                            placeholder=" "
                                            onClick={() => handleToggle(i, 'fonts')}
                                            value={custom?.[item?.key]?.['family'] || ''}
                                            readOnly
                                        />
                                        <label htmlFor={`fonts-${i}`} className={`${submitSelected && (custom[item?.key] === '' || !custom[item?.key]) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 absolute text-[#1F1F1F] block duration-300 transform -translate-y-4 scale-75 top-[18px] z-5 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 ${custom[item?.key] === '' || !custom[item?.key] ? 'text-base font-semibold' : 'text-lg font-normal peer-focus:-translate-y-4 peer-focus:scale-75'} `}>{item?.title}</label>

                                        <motion.img
                                            animate={{ rotate: fontDropdown[i] === true ? 180 : 0 }}
                                            src={`${submitSelected && (custom[item?.key] === '' || !custom[item?.key]) ? '/assets/images/error-chevron-down.svg' : '/assets/images/chevron-down.svg'}`}
                                            alt=""
                                            className="absolute cursor-pointer top-4 right-5"
                                            onClick={() => handleToggle(i, 'fonts')}
                                        />


                                    </div>
                                    {
                                        <ul className={`dropdown-menu absolute scrollBar w-full z-[100] max-h-[162px]  overflow-y-auto bg-white ${fontDropdown[i] ? 'show' : 'hidden'}`}>
                                            {fonts && fonts?.length > 0 ? fonts.map((font, index) => (

                                                <li
                                                    key={font?.family}
                                                    onClick={() => {
                                                        handlefontChange(font, item?.key);
                                                        handleToggle(i, 'fonts')

                                                    }}
                                                    data-testid={`font-${index}`}
                                                    // eslint-disable-next-line max-len
                                                    className="dropdown-item cursor-pointer w-full px-4 py-4 border border-[#DDDDDD] hover:bg-[#EB9DC7] rounded-[2px] text-sm font-semibold text-[#1F1F1F] overflow-hidden text-ellipsis whitespace-nowrap"
                                                >
                                                    {font?.family}
                                                </li>

                                            )

                                            ) :
                                                (<div className='border border-[#DDDDDD] h-[100px] flex justify-center items-center'>
                                                    No fonts available yet.
                                                </div>)

                                            }

                                        </ul>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            </div>) :

                (<div className='flex mb-8 -mx-3'>
                    <div className='relative w-1/4 px-3'>
                        <h1 className='mb-2 text-base font-normal'>Title Font Family</h1>
                        <h1 className='text-base font-semibold text-[1f1f1f]'>Playfair Display</h1>
                    </div>
                    <div className='relative w-1/4 px-3'>
                        <h1 className='mb-2 text-base font-normal'>Body Font Family</h1>
                        <h1 className='text-base font-semibold text-[1f1f1f]'>Playfair Display</h1>
                    </div>
                </div>)}
            {/* font picker ends here  */}

            {/* logo section starts here  */}
            <div className='flex gap-[17%]'>
                <div>
                    <h1 className={`text-lg font-normal text-[#1f1f1f] ${state?.custom_store_theme ? 'mt-[80px]' : 'mt-[32px]'} mb-[22px]`}>Store Logo</h1>
                    <div>
                        {/* <FileUploadInput
                            imageLoading={imageLoading}
                            setimageLoading={setimageLoading}
                            id={'store-logo'}
                            s3Prefix={'store-logo'}
                            state={custom}
                            setState={setCustom}
                            newState={state}
                        /> */}
                        <div>
                            <LogoUpload
                                imageLoading={imageLoading}
                                setimageLoading={setimageLoading}
                                id={'store_logo'}
                                s3Prefix={'store_logo'}
                                state={state}
                                setAllowUpdate={setAllowUpdate}
                
                                setState={setState}
                                newState={state}
                            />
                            {/* Error message when the logo is not uploaded */}
                            {!state?.store_logo && submitSelected && (
                                <p className="text-red-500 text-sm mt-2">Please upload a store logo.</p>
                            )}
                        </div>


                    </div>
                </div>
                <div>
                    {state?.custom_store_theme && <div> <h1 className='text-lg font-normal text-[#1f1f1f] mt-[80px] mb-[22px]'>Product Image View</h1>
                        <div class="status custom-toggle flex items-center mt-[22px] mb-5" >
                            <label class="switch" style={{ marginLeft: "" }}>
                                <input type="checkbox" id="clock_in_out" checked={state?.product_full_image_view=== true ? true : false} />
                                <span data-testid={`toggle-btn`} class={`slider round cursor-pointer`} onClick={handleFullToggle}></span>
                            </label>
                            <p className="text-black text-sm font-normal ml-3">{state?.product_full_image_view ? 'Full image view' : 'Default image view'}</p>
                        </div>
                    </div>
                    }
                </div>
            </div>
            {/* logo section ends here  */}
            {/* preview buttons starts here  */}
            {state?.custom_store_theme && (<div className='flex justify-end mb-6 space-x-6'>
                <button
                    // handleClick={handleSubmit}
                    // loading={}
                    // disabled={loading}
                    onClick={() => {
                        setModal(true)
                        setDropdown({
                            0: false,
                            1: false,
                            2: false,
                            3: false,
                        })
                    }}
                    className={`px-9 py-2 bg-white rounded-[12px] border border-[#9E2064] text-[#9E2064] text-base font-normal`}
                    type="submit"
                    data-testid={`preview-btn`}
                >Preview</button>
                {/* {edit && <button
                    // handleClick={handleSubmit}
                    // loading={}
                    // disabled={loading}
                    // text={"Save and Apply"}
                    onClick={() => popUpHandler()}
                    className={`px-9 py-2 bg-[#9E2064] rounded-[12px] border border-[#9E2064] text-white text-base font-normal`}
                    type="submit"
                    testId="save-apply-btn"
                >Save and Apply</button>} */}
            </div>)}
            {/* preview buttons ends here  */}

            {/* <ColorPicker onChange={handleChangeColor} /> */}

            <Modalcustom open={modal} onClose={handleClose} style={`items-center`}>
                <Preview state={state} handleClose={handleClose} />
            </Modalcustom>
            <Modalcustom open={saveModal} onClose={handleCloseSave} style={'items-start'} container={'mt-[50px]'}>
                <Confirmationpopup
                    message={`Please note: Any changes to the currency or GST will only `}
                    Title={`Update Store`}
                    handleSubmit={handleSubmitMain}
                    stateKey={`Update`}
                    loading={saveLoading}
                    closeIcon
                    handleClose={handleCloseSave}
                    extraText={`affect new orders and reservations. All product prices will be `}
                    additionalText={`updated to reflect the new currency values accordingly.`}
                />
            </Modalcustom>



            {/* <Modal open={saveModal} onClose={handleSaveClose} closeIcon={<button style={{ color: 'white' }} disabled></button>}>
                <CustomConfirmationpopup
                    message={`${areEqual ? 'Are you sure you want to save and apply the changes?' : 'Please note: Any changes to the currency or GST will only affect new orders and reservations. All product prices will be updated to reflect the new currency values accordingly.'}`}
                    Title={`Save Changes`}
                    handleSubmit={handleSubmitMain}
                    stateKey={`Save`}
                    loading={loading}
                    handleClose={handleSaveClose} />
            </Modal> */}


        </div>
    )
}

export default StoreCustomize
